<template>
  <div class="shoppingCart">
    <div class="title">
      <div>{{ $t('newApp.ADList.mc') }}</div>
    </div>
    <div class="container">
      <div class="tips">{{ $t('newApp.ADList.pfitriac') }}</div>
      <div class="locationInfo">
        <div class="title">
          <span class="fl_left">{{ $t('newApp.ADList.ri') }}</span>
          <span class="fl_right" @click="addLocationShow = true">{{ $t('newApp.ADList.na') }}</span>
          <!--        <span class="fl_right">修改</span>-->
        </div>
        <div class="content">
          <div class="selectedAddress" v-if="selectedAddress.province || selectedAddress.country">
            <div class="name">{{ selectedAddress.consignee }}<i class="iconfont icon-gouxuan" /></div>
            <span>{{ selectedAddress.consignee }}</span>
            <span v-if="!selectedAddress.countryType">{{ selectedAddress.province }} {{ selectedAddress.city }} {{
                selectedAddress.county
            }} {{ selectedAddress.street ? selectedAddress.street : '' }} {{
    selectedAddress.detailedAddress
}}</span>
            <span v-else>{{ selectedAddress.country }} {{ selectedAddress.detailedAddress }}</span>
            <span>{{ selectedAddress.consigneePhone }}</span>
            <div class="default" v-if="selectedAddress.isDefault" style="width: 110px;">{{ $t('newApp.ADList.da') }}</div>
            <!--<el-button type="text" v-if="!selectedAddress.isDefault">删除</el-button>-->
            <!--<el-button type="text">修改地址</el-button>-->
            <!--<el-button type="text" v-if="!selectedAddress.isDefault">设为默认地址</el-button>-->
          </div>
          <div class="zoomTemplate" v-show="zoomTemplateShow">
            <div v-for="(item, index) in addressList.slice(1)" :key="index">
              <div class="name" @click="positionChange(item, index)">{{ item.consignee }}</div>
              <span>{{ item.consignee }}</span>
              <span v-if="!item.countryType">{{ item.province }} {{ item.city }} {{ item.county }} {{ item.street ?
                  item.street : ''
              }} {{ item.detailedAddress }}</span>
              <span v-else>{{ item.country }} {{ item.detailedAddress }}</span>
              <span>{{ item.consigneePhone }}</span>
              <div class="default" v-if="item.isDefault" style="width: 110px;">{{ $t('newApp.ADList.da') }}</div>
              <!--<el-button type="text" v-if="!item.isDefault">删除</el-button>-->
              <!--<el-button type="text">修改地址</el-button>-->
              <!--<el-button type="text" v-if="!item.isDefault">设为默认地址</el-button>-->
            </div>
          </div>
          <div class="expandEntrance" :class="zoomTemplateShow ? 'openStyle' : ''" @click="expandEntranceHandler"
            v-show="addressList.length > 1" style="width: 140px;">
            {{ zoomTemplateShow ? $t('newApp.ADList.Collapse') : $t('newApp.ADList.Am') }}{{ $t('newApp.ADList.Address')
            }}<i class="iconfont icon-gengduo-icon" />
          </div>
        </div>
      </div>
      <commonTable ref="shoppingCartTable" />
    </div>
    <addLocationDialog :add-location-show="addLocationShow" :prevent-close-flag="preventCloseFlag"
      @dialogCloseHandle="dialogCloseHandle" @submitSuccess="addLocationSuccess" />
  </div>
</template>

<script>
import { locationManagementApi } from '../../service';
import commonTable from '@/components/commonTable';
import { TableRow, TableColumns } from '@/utils/tableOptions.js';
import addLocationDialog from './addLocationDialog';

export default {
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      formData: {},
      tableData: [{}],
      deliveryMethod: [
        {
          fieldKey: 'ORD_EXPRESS',
          fieldValue: this.$t('newApp.ADList.OE')
        },
        {
          fieldKey: 'SF_AIRLINES',
          fieldValue: this.$t('newApp.ADList.SfAir')
        },
        {
          fieldKey: 'SF_HIGHWAY',
          fieldValue: this.$t('newApp.ADList.SfE')
        }
      ],
      addressList: [],
      selectedAddress: {},
      addLocationShow: false,
      zoomTemplateShow: false,
      preventCloseFlag: false,
      shipmentsType: '0'
    };
  },
  props: {
    shoppingCartData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  watch: {
    selectedAddress: {
      immediate: true,
      deep: true,
      handler() {
        this.loadTable();
      }
    }

  },
  components: {
    commonTable,
    addLocationDialog
  },
  methods: {
    positionChange(val, index) {
      this.addressList[index + 1] = this.addressList.splice(0, 1, val)[0];
      this.selectedAddress = this.addressList[0];
      this.zoomTemplateShow = false;
      this.loadTable();
    },
    isRepeat(data, params) {
      if (Object.keys(this.selectedAddress).length > 0) {
        let val = data.consigneeName === params.consigneeName &&
          data.provinceCode === params.provinceCode &&
          data.cityCode === params.cityCode &&
          data.areaCode === params.areaCode &&
          data.detailedAddress === params.detailedAddress &&
          data.consigneePhone === params.consigneePhone;
        if (val && (data.streetCode || params.streetCode)) {
          val = data.streetCode === params.streetCode;
        }
        return val;
      }
      return false;
    },
    getAddressList() {
      locationManagementApi.getAddressList().then(res => {
        if (res.status === '200') {
          // 如果没有添加过地址，则必须添加地址，不能关闭添加弹框
          this.preventCloseFlag = !res.data.length > 0;
          if (res.data.length <= 0) {
            this.addLocationShow = true;
            return;
          }
          // 如果是编辑
          if (Object.keys(this.selectedAddress).length > 0) {
            let isRepeatFlage = res.data.some(item => {
              return this.isRepeat(item, this.selectedAddress);
            });
            // 判断其是否跟地址列表中的数据匹配，如果匹配则赋值，如果没有匹配则设置为默认地址
            if (isRepeatFlage) {
              this.addressList = res.data.filter(item => {
                if (this.isRepeat(item, this.selectedAddress)) {
                  this.selectedAddress.isDefault = item.isDefault;
                } else {
                  return item;
                }
              });
              this.addressList.unshift(this.selectedAddress);
              return;
            }
          }
          this.addressList = res.data.sort((a, b) => {
            return b.isDefault - a.isDefault;
          });
          this.selectedAddress = this.addressList[0];
        }
      });
    },
    expandEntranceHandler() {
      this.zoomTemplateShow = !this.zoomTemplateShow;
    },
    addLocationSuccess() {
      this.getAddressList();
      this.addLocationShow = false;
    },
    dialogCloseHandle() {
      this.addLocationShow = false;
    },
    setDefaultVal(val) {
      this.selectedAddress = {
        consignee: val.consigneeName,
        consigneePhone: val.consigneeTel,
        province: val.province,
        provinceCode: val.provinceCode,
        city: val.city,
        cityCode: val.cityCode,
        county: val.area,
        countyCode: val.areaCode,
        detailedAddress: val.detailedAddress,
        country: val.country,
        countryType: val.countryType
      };
      if (val.streetCode) {
        this.selectedAddress.street = val.street;
        this.selectedAddress.streetCode = val.streetCode;
      }
      // Promise.all([this.getCityList(), this.getAreaList()]).then(() => {
      //   this.formData = val;
      // });
    },
    clearFormData() {
      this.formData = {};
    },
    getFormData() {
      if (!this.selectedAddress.provinceCode && !this.selectedAddress.province && !this.selectedAddress.country) {
        this.addLocationShow = true;
        return;
      }
      // 省市区name获取
      // this.formData.province = this.arrayQuery(this.formData.provinceCode, this.provinceList, 'fieldKey').fieldValue;
      // this.formData.city = this.arrayQuery(this.formData.cityCode, this.cityList, 'fieldKey').fieldValue;
      // this.formData.area = this.arrayQuery(this.formData.areaCode, this.areaList, 'fieldKey').fieldValue;
      // // 货运方式name过滤
      // this.formData.deliveryMethod = this.arrayQuery(this.formData.deliveryMethodCode, this.deliveryMethod, 'fieldKey').fieldValue;
      let data = this.selectedAddress;
      let params = {
        consigneeName: data.consignee,
        consigneeTel: data.consigneePhone,
        detailedAddress: data.detailedAddress,
        province: data.province,
        provinceCode: data.provinceCode || '370000',
        city: data.city,
        cityCode: data.cityCode || '370400',
        area: data.county,
        areaCode: data.countyCode || '370402',
        countryType: data.countryType
      };
      if (data.streetCode) {
        params.street = data.street;
        params.streetCode = data.streetCode;
      }
      if (data.countryType) {
        params.country = data.country;
      }
      return params;
    },
    totalMoneyCount() {
      this.$emit('totalMoneyCount');
    },
    deleteBtn(row) {
      this.$refs.shoppingCartTable.removeRow(row);
      this.totalMoneyCount();
    },
    loadTable() {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.ADList.Pictures'))
          ._data('giftCoverUrl')
          ._width('160')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <img v-lazy={row[column.property]} />
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.ADList.noa'))
          ._data('giftName')
          ._width('160')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.ADList.up'))
          ._data('price')
          ._align('right')
          ._width('120')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.ADList.no'))
          ._data('amount')
          ._width('120')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <el-input-number
                  v-model={row[column.property]}
                  min={1}
                  precision={0}
                  onChange={() => {
                    let price = Number(row.price);
                    let num = Number(row.amount);
                    row.totalMoney = (price * num).toFixed(2);
                    this.totalMoneyCount();
                  }}
                />
              );
            }
          })
      );
      if (this.selectedAddress.countryType) {
        tableRow.push(
          new TableColumns()
            ._title(this.$t('newApp.ADList.sm'))
            ._data('shipmentState')
            ._width('180')
            ._align('right')
            ._cellType('customDom')
            ._cellData({
              formater: ({ row, column }) => {
                return (
                  <div class="radioContainer">
                    <el-radio v-model={row.shipmentState} label={this.$t('general.SetupSucc')} />
                    <el-radio v-model={row.shipmentState} label={this.$t('newApp.ADList.fcpos')} />
                  </div>
                );
              }
            })
        );
      }
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.ADList.Subtotal'))
          ._data('totalMoney')
          ._width('160')
          ._align('right')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let price = Number(row.price);
              let num = Number(row.amount);
              row.totalMoney = (price * num).toFixed(2);
              // let total = ;
              return (
                <span>{row[column.property]}</span>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('general.Operation'))
          ._width('100')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <el-button type="text" onClick={() => { this.deleteBtn(row); }}>
                  {this.$t('btn.Delete')}
                </el-button>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.$nextTick(() => {
        this.$refs.shoppingCartTable.setColumn(column, {
          page: false,
          border: 'default',
          highlightHoverRow: false,
          stripe: false,
          maxHeight: 'none'
        });
        this.$refs.shoppingCartTable.loadStaticTable(this.shoppingCartData);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/main";

.shoppingCart {
  width: 100%;
  height: 100%;

  >.title {
    width: 100%;
    background: #FFFFFF;
    line-height: 58px;

    >div {
      width: 1200px;
      margin: 0 auto;
      font-size: 18px;
      color: #424C57;
    }
  }

  >.container {
    width: 1200px;
    margin: 0 auto;

    >.tips {
      line-height: 50px;
      color: #5b646e;
    }

    >.locationInfo {
      border: 1px solid #DEE1E7;
      margin-bottom: 20px;

      >.title {
        line-height: 56px;
        background: #f6f7f9;
        padding: 0 20px;
        @extend .clear;
        position: relative;
        border-bottom: 1px solid #DEE1E7;

        &:before {
          content: "";
          width: 100%;
          height: 1px;
          display: block;
          position: absolute;
          left: 0;
          top: 0;
          background: #FFFFFF;
        }

        >.fl_left {
          color: #424C57;
          font-weight: bold;
        }

        >.fl_right {
          color: #508DB4;
          cursor: pointer;
        }
      }

      >.content {
        background: #FFFFFF;
        padding: 20px;

        >.selectedAddress,
        >.zoomTemplate>div {
          line-height: 30px;
          margin-bottom: 10px;
          @extend .clear;

          >.name {
            min-width: 60px;
            padding: 0 5px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            float: left;
            border: 1px solid #14937B;
            color: #14937B;
            cursor: pointer;
            position: relative;
            margin-right: 8px;

            >i {
              position: absolute;
              bottom: -1px;
              right: -1px;
              line-height: 16px;
              font-size: 16px;
              color: #14937B;
            }
          }

          >span {
            float: left;
            color: #424C57;
            margin-left: 12px;
          }

          >.default {
            width: 80px;
            line-height: 26px;
            float: left;
            margin-left: 20px;
            margin-top: 2px;
            text-align: center;
            background: #D9F5F0;
            color: #14937B;
            cursor: default;
            border-radius: 2px;
          }

          >.el-button {
            width: auto;
            min-width: 0;
            padding: 0 !important;
            float: right;
            margin-left: 20px;
          }
        }

        >.zoomTemplate {
          >div {
            @extend .selectedAddress;

            >.name {
              border-color: #B8B8B8;
              color: #424C57;

              &:hover {
                border-color: #14937B;
                color: #17A58A;
              }
            }
          }
        }

        >.expandEntrance {
          width: 100px;
          cursor: pointer;
          margin-top: 4px;
          color: #5B646E;

          &.openStyle>i {
            transform: scale(.5) translate(-1px) rotate(180deg);
          }

          >i {
            display: inline-block;
            transform: scale(.5) translate(-1px);
            font-size: 14px;
            transition: .3s;
          }
        }
      }
    }

    ::v-deep>.el-form {
      >.content {
        >.selectedAddress {
          color: #666;
          font-size: 12px;
          @extend .clear;

          >.name {
            // width: 80px;
            height: 30px;
            line-height: 26px;
            border: 2px solid #3384FE;
            text-align: center;
            float: left;

            &:hover {
              cursor: pointer;
            }
          }

          >span {
            float: left;
            margin-left: 10px;
          }
        }

        >.zoomTemplate {
          >div {
            margin-top: 12px;
            line-height: 30px;
            color: #666;
            font-size: 12px;
            @extend .clear;

            >.default {
              margin-left: 10px;
              margin-top: 3px;
              padding: 2px 4px;
              background: #999999;
              color: #FFFFFF;
              line-height: normal;
              float: left;
              font-size: 12px;
            }

            >.name {
              width: 140px;
              height: 30px;
              line-height: 26px;
              border: 2px solid #dddddd;
              text-align: center;
              float: left;

              &:hover {
                border-color: #3384FE;
                cursor: pointer;
              }
            }

            >span {
              float: left;
              margin-left: 10px;
            }
          }
        }
      }
    }

    ::v-deep .vxe-table {
      .vxe-cell {
        text-overflow: clip;
        white-space: normal;

        >img {
          width: 100%;
          margin-top: 4px;
        }

        >input {
          text-align: center;
        }

        .radioContainer {
          display: flex;
          flex-direction: column;

          .el-radio {
            margin-left: 30px;
            margin-right: 0;
            display: flex;
            justify-content: flex-start;
            margin-bottom: 5px;
          }
        }
      }
    }
  }

}
</style>
